import { useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { Buildings, LockKey } from "@phosphor-icons/react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) return toast.error("At least 6 characters");
    if (password !== confirm) return toast.error("Passwords do not match");
    setLoading(true);
    try {
      await axios.post(`${API}/auth/reset-password`, { token, password });
      setDone(true);
      toast.success("Password reset — you can sign in");
      setTimeout(() => nav("/login"), 1500);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Reset failed");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F9]">
      <div className="w-full max-w-sm bg-background border border-border p-8">
        <div className="flex items-center gap-2 mb-6">
          <Buildings size={20} weight="duotone" />
          <span className="font-mono uppercase tracking-[0.2em] text-xs">Specfield Management Services Sdn. Bhd.</span>
        </div>
        <div className="font-mono text-xs uppercase tracking-[0.2em] text-muted-foreground">Reset password</div>
        <h2 className="mt-2 text-2xl font-semibold tracking-tight">Choose a new password</h2>

        {done ? (
          <div className="mt-6 text-sm text-muted-foreground">
            Password updated. Redirecting to sign-in…
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="reset-form">
            <div>
              <Label className="font-mono text-xs uppercase tracking-wider">New password</Label>
              <Input type="password" required minLength={6} value={password}
                     onChange={e => setPassword(e.target.value)}
                     className="rounded-sm h-11 mt-1" data-testid="reset-password-input" />
            </div>
            <div>
              <Label className="font-mono text-xs uppercase tracking-wider">Confirm password</Label>
              <Input type="password" required minLength={6} value={confirm}
                     onChange={e => setConfirm(e.target.value)}
                     className="rounded-sm h-11 mt-1" data-testid="reset-confirm-input" />
            </div>
            <Button type="submit" disabled={loading}
                    className="w-full h-11 rounded-sm bg-[#0F62FE] hover:bg-[#0043CE]"
                    data-testid="reset-submit-btn">
              <LockKey size={16} weight="bold" className="mr-2" />
              {loading ? "Resetting…" : "Reset password"}
            </Button>
            <div className="text-sm">
              <Link to="/login" className="underline">Back to sign in</Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
